import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts'

interface ChannelBreakdownItem {
  channel: string
  sessions: number
}

interface ChannelBreakdownChartProps {
  data: ChannelBreakdownItem[]
}

const CHART_COLORS = ['#8b5cf6', '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#6366f1', '#ec4899', '#14b8a6']

export default function ChannelBreakdownChart({ data }: ChannelBreakdownChartProps) {
  if (data.length === 0) return null

  return (
    <div className="border border-border rounded-lg p-3 flex flex-col items-center">
      <ResponsiveContainer width="100%" height={100}>
        <PieChart>
          <Pie data={data} dataKey="sessions" nameKey="channel" cx="50%" cy="50%" outerRadius={40} innerRadius={20}>
            {data.map((_entry, index) => (
              <Cell key={index} fill={CHART_COLORS[index % CHART_COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [`${value} sessões`, '']} />
        </PieChart>
      </ResponsiveContainer>
      <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 mt-1">
        {data.map((entry, index) => (
          <span key={index} className="flex items-center gap-1 text-[10px] text-muted-foreground">
            <span className="inline-block w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: CHART_COLORS[index % CHART_COLORS.length] }} />
            <span className="truncate max-w-[80px]">{entry.channel}</span>
          </span>
        ))}
      </div>
    </div>
  )
}
